import React from 'react'
import './Login.scss'
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import KITCHEN_PNG from "../../global/assets/png/Kitchen-FirstTimeChecker.png"
import LoginForm from '../../composed/loginflow/LoginForm'
import Transition from './../../transition';

const Login = () => {

    if (isMobile || isIpad) {

        return (
            <LoginForm />
        )
    }


    return (
        <div className='login-desktop-container'>

            <div className='section-1-login-desktop'>

                {/* <img style={{ width: '100%', }} src={KITCHEN_PNG}></img> */}

            </div>
            <div className='section-2-login-desktop'>  <LoginForm /> </div>

        </div>
    )
}

export default Transition(Login)